import { useRevisionTrigger } from '@weezevent/revisor-front';

export function useRevision(ref) {
    const { model, id } = ref || {};
    const trigger = useRevisionTrigger(model, id);
    return { ...trigger, model, id, canSeeHistory: trigger.isAdmin && !!id };
}
